import BaseService from "./BaseService";

class TennantConfigService {
  static async GetTennantConfigs(tennantId, token) {
    try {
      return await BaseService.get("tennants-config", token, { tennantId });
    } catch (error) {
      console.error("There was an error fetching the tennants configs!", error);
      throw error;
    }
  }
}

export default TennantConfigService;
